import { render, staticRenderFns } from "./CreateCommitmentContainer.vue?vue&type=template&id=5904a4bc&scoped=true&lang=html&"
import script from "./CreateCommitmentContainer.vue?vue&type=script&lang=js&"
export * from "./CreateCommitmentContainer.vue?vue&type=script&lang=js&"
import style0 from "./CreateCommitmentContainer.vue?vue&type=style&index=0&id=5904a4bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5904a4bc",
  null
  
)

export default component.exports